import * as React from 'react';
import Modal from '@mui/material/Modal';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import SensorAdminDelte from "./SensorDeleteModal"
import { useCookies } from 'react-cookie';
import baseUrlApi from '../../lib/baseUrlApi';
import sensorKindConsts from "../../Consts/SensorKinds";
import Rule from "../../Consts/Rules";
import Utility from "../../Consts/Utility";
import {ApiRequest} from "../../Consts/ApiRequest";
import { modalProps } from '../../Consts/constants';

type SensorAdminInputs = {
  sensorID: string;
  sensorName: string;
  sensorKind: number;
  sensorRecno: string;
  setState: Function;
};

interface SensorAdminProps {
  data: SensorAdminInputs[];
}

export default function BasicModal(props: SensorAdminInputs) {
  const [open, setOpen] = React.useState(false);
  const [SensorAdminData, setSensorAdminData] = useState<SensorAdminInputs[]>([]);
  const [sensorID, setSensorID] = useState<string>(props.sensorID);
  const [sensorName, setSensorName] = useState<string>(props.sensorName);
  const [sensorKind, setSensorKind] = useState<number>(props.sensorKind);
  const [sensorRecno, setSensorRecno] = useState<string>(props.sensorRecno);

  const { register, reset, handleSubmit, formState: { errors } } = useForm<SensorAdminInputs>({
    defaultValues: {
      sensorID: props.sensorID,
      sensorName: props.sensorName,
      sensorKind: props.sensorKind,
    }
  });
  const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
  const navigate = useNavigate();
  const [error, setError] = useState<string[]>([]);
  const setState = props.setState;

  const resetData = async() => {
    console.log(".........");
    console.log(props.sensorName);
    setSensorID(props.sensorID);
    setSensorName(props.sensorName);
    setSensorKind(props.sensorKind);
    setError([]);
    reset();
};

  const handleOpen = async() => {
    await resetData();
    await reset();
    setOpen(true);
  }

  const handleClose = async() => {
    await resetData();
    await reset();
    setOpen(false);
  }

  const rules1 = {
    required: '',
    maxLength: {
      value: 100,
      message: ""
    },
  }
  const rules2 = {
    maxLength: {
      value: 60,
      message: ""
    },
  }

  const rules3 = {
    required: '',
  }

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

  const onSubmit = async () => {
    try {
        const token = cookies.access_token || "";
        let params = {
            "prcKind": 1,
            "sensorInfo": {
                "sensorID": sensorID,
                "sensorName": sensorName,
                "sensorRecno": sensorRecno,
                "sensorKind": Number(sensorKind)
            },
        };
        await ApiRequest.registSensor(params, token, (response: any) => {
            setError(response.data.messsages);
            if (Array.isArray(response.data)) {
                console.log(response.data);
                setSensorAdminData(response.data);
            }
            if (response.data.result === 0) {
                handleClose();
            }
            props.setState(" ")
        }, (error: any) => {
            errorCallback(error);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("エラーが発生しました");
    }
  };

  return (
    <div>
      <button onClick={handleOpen} className="btn btn-blue-line"><i className="icon-edit-b"></i>編集</button>
      <Modal {...modalProps} open={open}>
        <div className="modal-wrapper" style={{ display: "flex" }} id="modal-message">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">
                センサ編集
              </div>
              <a onClick={handleClose} className="modal-close"></a>
            </div>
            <div className="modal-body">
              <div className="edit-box">
                <div className="edit-box-elm">
                  {
                    (error.length > 0 || !Utility.isEmpty(errors)) ?
                        <ul className="error-box">
                            {error.map((item, index) => (
                                <li>{item}</li>
                            ))}
                          {errors.sensorID && <li>センサ管理番号は100文字以下の半角英数字及びハイフンで入力してください。</li>}
                          {errors.sensorName && <li>センサ名は100文字以下の半角英数字及びハイフンで入力してください。</li>}
                          {errors.sensorKind && <li>センサ種別を選択してください。</li>}
                        </ul>
                        : null
                  }
                  <div className="edit-box-elm-name">センサ管理番号<span className="required"></span></div>
                  <div className="edit-box-elm-input">
                    <input
                      type="text"
                      defaultValue={sensorID}
                      placeholder="sensorID"
                      //WARNING:rules_string_100だとローカルで設定されたrule1とメッセージ内容が違う。
                      onChange={(e) => setSensorID(e.target.value)}
                      className={"col-320"}
                    />
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">センサ名<span className=""></span></div>
                  <div className="edit-box-elm-input">
                    <input
                      type="text"
                      defaultValue={sensorName}
                      placeholder="sensorName"
                      //WARNING:バリデーションルールが適用されてません。
                      onChange={(e) => setSensorName(e.target.value)}
                      className={"col-320"}
                    />
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">センサ種別</div>
                  <div className="edit-box-elm-input col-320">
                    <select
                      defaultValue={sensorKind}
                      onChange={(e) => setSensorKind(Number(e.target.value))}
                      className={"col-320"}
                    >
                      {sensorKindConsts.kinds.map((item, index) => (
                        <option value={item.index} key={item.index}>{item.name}</option>
                      ))}
                    </select>
                    {errors.sensorKind && <p className="error-msg">{errors.sensorKind.message}</p>}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="model-action-sub">
                <SensorAdminDelte sensorID={sensorID} sensorName={sensorName} sensorKind={sensorKind} closeModal={handleClose} sensorRecno={sensorRecno} setState={setState}/>
              </div>
              <div className="model-action-main">
                <button className="btn btn-blue-line">
                  <a onClick={handleClose} className="">
                    キャンセル
                  </a>
                </button>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <button className="btn btn-blue col-160">
                    <i className="icon-check-w"></i>確定
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
